module.exports = {"411322001":"凤瑞街道","411322002":"释之街道","411322101":"独树镇","411322102":"博望镇","411322103":"拐河镇","411322104":"小史店镇","411322105":"赵河镇","411322106":"广阳镇","411322107":"二郎庙镇","411322108":"杨楼镇","411322300":"券桥乡","411322301":"杨集乡","411322303":"古庄店乡","411322306":"清河乡","411322309":"柳河乡","411322310":"四里店乡","411322311":"袁店回族乡","411322400":"河南中南机械厂","411322401":"方城大寺林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411322.json
// module id = 1499
// module chunks = 0